import { Box } from '@mui/material'
import Grid2 from '@mui/material/Grid2'
import { styled } from '@mui/material/styles'
import React from 'react'

import { ChatbotConfigs } from '@/app/module/campaigns/types'

import ChatbotConfigsForm from './configs'

type Props = {
  campaignId?: number | string
  name: string
  configs?: ChatbotConfigs
  onConfigsChange: (cfg: ChatbotConfigs) => void
}

const ChatbotContent: React.FC<Props> = ({ configs, onConfigsChange }) => (
  <Container>
    <Grid2 container spacing={2} alignItems="stretch" sx={{ mb: 2, height: { xs: 'auto', md: '100%' } }}>
      <Grid2
        size={{ xs: 12 }}
        sx={{
          height: { xs: 'auto', md: '100%' },
        }}
      >
        {configs && <ChatbotConfigsForm configs={configs} onChange={onConfigsChange} />}
      </Grid2>
    </Grid2>
  </Container>
)

const Container = styled(Box)(() => ({
  flex: 1,
  width: '100%',
  minHeight: 0,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
}))

export default ChatbotContent
